import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import TextBlock from '../text-block';
import { listTextStatic } from '../../../../cases-new/medved/constants';

const StatisticBlock = ({ listStatistic }) => {
    return (
        <div className="statistic-block">
            <FullWrapper isMargin={0}>
                {listStatistic.map((item, index) => (
                    <div key={index} className="statistic-block-container">
                        <div className="statistic-block-header">
                            <div
                                dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                className="statistic-block-header__subtitle"
                            />
                            <a
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                                className="statistic-block-header__link"
                            >
                                Перейти к статье
                            </a>
                        </div>
                        <div className="statistic-block-item">
                            {item.info.map((value, idx) => (
                                <div key={idx} className="statistic-block-info">
                                    <div className="statistic-block-info__top">
                                        <div className="statistic-block-info__top-text">
                                            {value.text}
                                        </div>
                                        <img
                                            src={value.icon}
                                            alt="statistic-icon"
                                            className="statistic-block-info__top-icon"
                                        />
                                    </div>
                                    <div className="statistic-block-info__number">
                                        {value.number}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </FullWrapper>
            <TextBlock listText={listTextStatic} />
        </div>
    );
};
export default StatisticBlock;
